export default __webpack_public_path__ + "static/sprzedaż-9e81af4af32ec05a74d82bb1d48bd305.webp";